// angular
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

// services
import { InvestorService } from '@core/services';

// addons
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';

// store
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as actions from './actions';

// models
import { IUser } from '@shared/models';

@Injectable()
export class MembersEffects {
  loadMembers = createEffect(() => this.actions$.pipe(
    ofType(actions.ActionTypes.Load),
    mergeMap(() => {
      return this.investorService.getAllUsers().pipe(
        map((members: IUser[]) => actions.loadSuccess({ members })),
        catchError(error => of(actions.loadFail({ error })))
      );
    })
  ));

  constructor(
    private actions$: Actions,
    private investorService: InvestorService,
    private route: ActivatedRoute,
    private router: Router
  ) {}
}
